import type { FC } from "react";
import { SearchModalLoadingRow } from "./searchModalLoadingRow.js";
import { SearchModalSection } from "./searchModalSection.js";

export interface SearchModalLoadingSectionViewProps {
  title: string;
  rowCount?: number;
  showBadge?: boolean;
  showTrailing?: boolean;
}

const defaultRowCount = 3;

export const SearchModalLoadingSectionView: FC<
  SearchModalLoadingSectionViewProps
> = (props) => {
  const {
    title,
    rowCount = defaultRowCount,
    showBadge = false,
    showTrailing = false,
  } = props;

  return (
    <SearchModalSection title={title}>
      {Array.from({ length: rowCount }).map((_, index) => (
        <SearchModalLoadingRow
          key={index}
          index={index}
          showBadge={showBadge}
          showTrailing={showTrailing}
        />
      ))}
    </SearchModalSection>
  );
};
